export const reducePoolStatus = (aKey: string) => {
  let key = '';
  switch (aKey) {
    case '0':
    case '1':
    case '2':
    case '3':
    case '5':
      key = 'open';
      break;
    case '4':
    case '6':
    case '7':
      key = 'closed';
      break;
    default:
      break;
  }

  return key;
};
export const reduceCheckAndPushKey = (acc: any, key: string, item: any) => {
  if (!acc[key]) {
    acc[key] = [];
  }
  acc[key].push(item);
  return acc;
};
